import { render, staticRenderFns } from "./PrepLesson.vue?vue&type=template&id=01df84be&scoped=true&"
import script from "./PrepLesson.vue?vue&type=script&lang=js&"
export * from "./PrepLesson.vue?vue&type=script&lang=js&"
import style0 from "./PrepLesson.vue?vue&type=style&index=0&id=01df84be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01df84be",
  null
  
)

export default component.exports